<a class="office-card" [routerLink]="[office.detailUrl]">
  <div [jsonSchema]="office.jsonLdSchema"></div>
  <div class="caption-1">
    <h5 class="name wrap-word"><a [routerLink]="[office.detailUrl]">{{office.officeName}}</a></h5>
    <div class="divider"></div>
    <div class="address">
      <p><span >{{office.address1}}{{office.address2 ? ' ' + office.address2 : ''}}</span>, <span>{{office.city}}, {{office.state}}</span></p>
      <p><span >{{office.postalCode}}</span>, {{office.country}}</p>
    </div>
  </div>
  <p class="contact is-flex has-flex-align-center has-flex-content-space-between" (click)="$event.stopPropagation();" >
    <app-card-contact-info [emailTitle]="'office-profile.aria.email-office'"
                           [callTitle]="'office-profile.aria.call-office'" [contactObject]="office"
                           (onContactObjectClicked)="onOfficeEmailClicked.emit(office)"></app-card-contact-info>
  </p>
</a>
